import { Report1 } from "../../components/report";

export default function ReportData1() {
  return <Report1 />;
}
